import React from "react";
import PropTypes from "prop-types";
import CHEVRON from "@common/images/chevron_blue.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";

import style from "./style.module.scss";

export function ChevronIcon(props) {
  const className = props.expanded ? style.chevron_less : style.chevron_more;

  return <Image className={className} src={CHEVRON} alt="" />;
}

ChevronIcon.propTypes = {
  /**
   * specifies if transcript is hidden or not
   */
  expanded: PropTypes.bool,
};
